import * as types from 'framework/vuex/mutation-types';
import { find } from 'lodash';

export default {
    /**
     * Set all items in store
     * @param {object} state
     * @param {IPaymentMethodListItem[] }items
     */
    [types.SET_PAYMENTMETHOD_ITEMS](state, { items }) {
        state.items = items;
    },

    /**
     * Set the overlay reference to an item
     * @param {object} state
     * @param {number} item
     * @param {string} overlayId
     */
    [types.SET_PAYMENTMETHOD_ITEM_OVERLAYREF](state, { hash, overlayId }) {
        const overlayItem = find(state.items, { hash_id: hash });
        overlayItem.overlayId = overlayId;
    },
};
